"use strict";

const breakpointsMap = {
  xs: 0,
  sm: 540,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1320,
};

export { breakpointsMap };
